'use es6';

import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

var _handleActions;

import { handleActions } from 'flux-actions';
import * as ActionTypes from 'MeetingsLib/redux/actions/ActionTypes';
import { INVALID_TZ_GUESS } from 'MeetingsLib/constants/timezone';
import getTimezoneGroups from 'timezone-utils/utils/getTimezoneGroups';
var initialState = 'Europe/Belfast';
export default handleActions((_handleActions = {}, _defineProperty(_handleActions, ActionTypes.SET_TIMEZONE, function (state, action) {
  return action.timezone;
}), _defineProperty(_handleActions, ActionTypes.PUBLIC_AVAILABILITY_INFO_FETCH_SUCCEEDED, function (state, action) {
  var timezone = action.payload.bookInfo.customParams.timezone;

  if (state === INVALID_TZ_GUESS) {
    return getTimezoneGroups().resolve(timezone);
  }

  return state;
}), _handleActions), initialState);